import { GuardedComponent } from '../components/guarded-component';
import { PermissionErrorComponent } from '../components/permission-error.component';
import { PlanLibraryPage } from '../features/plan-library/plan-library.page';
import { UserPermissionName } from '../models/user-permission-name';

const isPlanEnabled = process.env.REACT_APP_PLAN_FLAG === 'true';

export const PlanLibraryRoute = {
  path: '/plan-library',
  name: 'Plan Library',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PLAN]} showPermissionError>
          {isPlanEnabled ? <PlanLibraryPage /> : <PermissionErrorComponent />}
        </GuardedComponent>
      ),
    },
  ],
};
